<template>
  <div>
    <div class="parent" :style="style">
      <v-card @click="showAyinDetail">
        <div class="parent-side">
          <v-card-title class="info-title">
            <div class="text-center">
              {{ ayin.ayinSubject }}
            </div>
          </v-card-title>
          <div>
            <app-row title="نام:" :value="ayin.ayinName" />
            <app-row title="جنسیت:" :value="ayin.jensiat" />
            <app-row title="مقطع:" :value="ayin.maqta" />
          </div>
          <div v-if="showSelectedDetails">
            <v-spacer></v-spacer>
            <v-card
              class="d-flex align-center flex-column"
              style="margin-top: 0; padding-top: 0;"
            >
              <v-card-title>
                توضیحات
              </v-card-title>
              <v-card-subtitle>
                <div class="text">
                  <span v-html="convertHTMLBody(ayin.description)"></span>
                </div>
              </v-card-subtitle>
            </v-card>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
import { convertHTMLBody } from "@/utils/constants";

export default {
  props: ["ayin", "index", "selectedIndex", "showDetails"],
  components: {
    appRow: DetailRow,
  },
  data: () => ({
    show: false,
  }),
  methods: {
    showAyinDetail() {
      this.$emit("clicked", this.index);
    },
    convertHTMLBody,
  },
  computed: {
    showSelectedDetails() {
      if (this.showDetails && this.selectedIndex === this.index) {
        return true;
      }
      return false;
    },
    style() {
      var res = "";
      if (this.$store.getters.isMobile) {
        res = "width: 100%";
      } else {
        res = "width: calc(100% - 300px)";
      }
      return res;
    },
  },
  created() {},
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px 15px 0px 0px !important;
  width: auto;
}

.v-card {
  display: flex !important;
}
.rotated {
  transform-origin: 113px 113px;
  width: 226px;
}
.parent-side {
  border-radius: 15px 15px 0px 15px !important;
  width: 100%;
}
.flex-card {
  display: flex;
  direction: column;
  justify-content: center;
  align-items: center;
}
#textWrap {
  line-break: anywhere;
  text-align: center;
  text-wrap: wrap;
  margin: auto;
}
</style>
